<script>
import http from "@/service/http";
import { mapState, mapGetters } from "vuex";
import { ListSelect } from "vue-search-select";
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import moment from "moment";
import truncate from "lodash/truncate";

export default {
  name: "Form",
  components: {
    ListSelect
    // VueGoogleAutocomplete
  },
  data() {
    return {
      hospitais: [],
      hospital: {},
      usuarios: [],
      status: [],
      produtos: [],
      equipamentos: [],
      lancar_financeiro: false,
      gerar_texto: false,
      mesmo_cliente: false,
      revisoes: [],
      viatura: {},
      historico: {
        data: "-",
        usuario: false,
        conteudo: ""
      },
      os: {
        gerar_orcamento: false,
        id: "",
        cliente_id: "",
        orcamento_id: "",
        proposta_id: "",
        revisao_id: null,
        servico: "",
        apartamento: "",
        medidor: "",
        medidor_marca: "",
        medidor_numero: "",
        medidor_leitura: "",
        descricao: "",
        dificuldades: "",
        solucao: "",
        valor: "",
        inicio: "",
        tempo_execucao: "",
        responsavel_id: "",
        cliente: {},
        orcamento: {},
        orcamentos: [],
        proposta: {},
        fotos: [],
        videos: [],
        historico: [],
        produtos: [],
        tarefas: [],
        envolvidos: [],
        pt_planejamento: [],
        pt_epis: [],
        pt_antes: [],
        pt_depois: [],
        pt_responsavel_id: "",
        pt_data_aprovacao: "",
        ip1: true,
        ip2: true,
        ip3: true,
        ip4: true,
        if1: true,
        if2: true,
        if3: true,
        if4: true,
        endereco: "",
        lat: "",
        long: "",
        le_data: "",
        le_instalacao: "",
        le_ponto_medicao: "Rede Interna",
        le_gas: "Gás Natural",
        le_teste1_casa: "",
        le_teste1_complemento: "",
        le_teste1_duracao: "",
        le_teste1_mmca: "",
        le_teste1_kgf: "",
        le_teste1_mmcab: "",
        le_teste1_kgfb: "",
        le_teste1_aprovado: true,
        le_teste2_gas: "",
        le_teste2_casa: "",
        le_teste2_complemento: "",
        le_teste2_duracao: "",
        le_teste2_mmca: "",
        le_teste2_kgf: "",
        le_teste2_mmcab: "",
        le_teste2_kgfb: "",
        le_teste2_aprovado: true,
        le_aprovado: true,
        le_responsavel_id: "",
        le_dados: "",
        equipamentosUtilizados: [],
        documento_assinado: "",
        financeiro: [],
        revisoes: [],
        revisao_aprovada: null,
        vistoria_realizada: false,
        vistoria_aprovada: false,
        tipo: "1",
        cnpj: "",
        razao_social: "",
        ie: "",
        responsavel: "",
        cpf: "",
        rg: "",
        email: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        isometrico: "",
        bairro: "",
        cidade: "",
        estado: "",
        referencia: "",
        mesmo_cliente: false,
        caracteristicas: [],
        isometricos: "",
        aprovacao_kitgas: 0,
        aprovacao_comgas: 0,
        comprovante_pagamento: "",
        hospital: "",
        endereco_hospital: "",
        telefone_hospital: ""
      },
      item: {
        id: "",
        produto: "",
        valor: "",
        qtd: ""
      },
      progress: 0,
      progress2: 0,
      errorFile: false,
      options: {
        url: `${process.env.API_URL}/upload-image-area`,
        uploadMultiple: true,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 800,
          height: 600,
          accept: "all"
        }
      },
      options2: {
        url: `${process.env.API_URL}/upload-documento-assinado`,
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          path: "os",
          accept: "all"
        }
      },
      options3: {
        url: `${process.env.API_URL}/upload-image`,
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 1920,
          height: 1080,
          accept: "all"
        }
      },
      options4: {
        url: `${process.env.API_URL}/upload-image`,
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 1920,
          height: 1080,
          accept: "all"
        }
      },
      editorDescricao: {
        placeholder: "Descrição",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      },
      editorDificuldades: {
        placeholder: "Dificuldades Encontradas",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      },
      editorSolucao: {
        placeholder: "Solução Proposta",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      }
    };
  },
  mounted() {
    this.fecth();
  },
  watch: {
    $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async fecth() {
      this.clear();
      const { id } = this.$route.params;
      if (id !== undefined) {
        const { data } = await http.get(`/os/${id}/edit`);
        this.os = data.os;
        this.status = data.status;
        this.produtos = data.produtos;
        this.usuarios = data.usuarios;
        this.equipamentos = data.equipamentos;
        this.revisoes = data.revisoes;
        this.viatura = data.viatura;
        this.hospitais = data.hospitais;
        // this.$refs.address.update(data.os.endereco)
        if (!this.os.le_teste1_casa && this.os.orcamento) {
          this.os.le_teste1_casa = this.os.orcamento.numero;
          this.os.le_teste1_complemento = this.os.orcamento.complemento;
          this.os.le_teste2_casa = this.os.orcamento.numero;
          this.os.le_teste2_complemento = this.os.orcamento.complemento;
        }

        if (this.os.cliente) {
          this.os.tipo = 2;
          this.os.cnpj = "";
          this.os.razao_social = this.os.cliente.razao_social;
          this.os.ie = "";
          this.os.responsavel = "";
          this.os.cpf = "";
          this.os.rg = "";
          this.os.email = "";
          this.os.telefone = "";
          this.os.telefone2 = "";
          this.os.telefone3 = "";
          this.os.cep = this.os.cliente.cep;
          this.os.logradouro = this.os.cliente.logradouro;
          this.os.numero = this.os.cliente.numero;
          this.os.complemento = this.os.apartamento;
          this.os.bairro = this.os.cliente.bairro;
          this.os.cidade = this.os.cliente.cidade;
          this.os.estado = this.os.cliente.estado;
          this.os.referencia = this.os.cliente.referencia;
        }
      } else {
        this.$router.push({ name: "os.index" });
      }
      setTimeout(function() {
        $(".collapsible").collapsible();
        $(".collapsible").collapsible("close", 0);
        $(".collapsible").collapsible("close", 1);
        $(".collapsible").collapsible("close", 2);
        $(".collapsible").collapsible("close", 3);
        $(".collapsible").collapsible("close", 4);
        $(".collapsible").collapsible("close", 5);
        $(".collapsible").collapsible("close", 6);
        $(".collapsible").collapsible("close", 7);
        $(".collapsible").collapsible("close", 8);
        $(".collapsible").collapsible("close", 9);
        $(".collapsible").collapsible("close", 10);
        $(".collapsible").collapsible("close", 11);
        $(".collapsible").collapsible("close", 12);
        $(".collapsible").collapsible("open", 0);
        window.Materialize.updateTextFields();
      }, 0);
    },
    setEndereco() {
      window.$.getJSON(
        `https://viacep.com.br/ws/${this.orcamento.cep}/json/`
      ).then(response => {
        if (!response.erro) {
          this.orcamento.logradouro = response.logradouro;
          this.orcamento.bairro = response.bairro;
          this.orcamento.cidade = response.localidade;
          this.orcamento.estado = response.uf;
          $("#numero").focus();
        } else {
          this.orcamento.logradouro = "";
          this.orcamento.numero = "";
          this.orcamento.complemento = "";
          this.orcamento.bairro = "";
          this.orcamento.cidade = "";
          this.orcamento.estado = "";
        }
        setTimeout(function() {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    validate() {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: "Ops, encontramos um erro!",
            html: "Um ou mais campos estão com seu preenchimento incorreto",
            type: "error",
            cancelButtonText: "Ok"
          });
          return false;
        }
        this.submit();
      });
    },
    async submit() {
      const verb = "put";
      const url = `/os/${this.os.id}`;
      const { data } = await http[verb](url, this.os);
      if (data != null) {
        this.$emit("update-os-list", { os: data.os });
        if (this.lancar_financeiro === true) {
          this.$router.push({
            name: "financeiro-receber.os",
            params: { id: data.os[0].id }
          });
        } else if (this.os.gerar_orcamento === true) {
          await http.post(`/os/gerar-orcamento/${this.os.id}`, this.os);
          this.$router.push({ name: "os.index" });
        } else {
          this.$router.push({ name: "os.index" });
        }
      }
    },
    adicionarRevisao: function() {
      if (this.os.revisao_id) {
        this.$swal({
          title: `Iniciar Revisão`,
          text: "Caso já exista itens na revisão eles serão removidos",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Iniciar",
          reverseButtons: true
        })
          .then(async () => {
            const { data } = await http.get(
              `revisao-itens/${this.os.revisao_id}/${this.os.id}`
            );
            if (data != null) {
              this.os.revisoes = data.revisoes;
            }
          })
          .catch(this.$swal.noop);
      }
    },
    gerarOrcamento: function() {
      if (this.os) {
        this.$swal({
          title: `Gerar Orçamento?`,
          // text: 'Caso já exista itens na revisão eles serão removidos',
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Gerar",
          reverseButtons: true
        }).then(async () => {
          const { data } = await http.get(`/os/gerar-orcamento/${this.os.id}`);
          if (data != null) {
            window.Materialize.toast("Orçamento gerado!", 4000);
          }
        });
      }
    },
    truncate: function(string = "") {
      return truncate(string);
    },
    clear() {
      this.os = {
        id: "",
        cliente_id: "",
        orcamento_id: "",
        proposta_id: "",
        revisao_id: null,
        servico: "",
        apartamento: "",
        medidor: "",
        medidor_marca: "",
        medidor_numero: "",
        medidor_leitura: "",
        descricao: "",
        dificuldades: "",
        solucao: "",
        valor: "",
        inicio: "",
        tempo_execucao: "",
        responsavel_id: "",
        cliente: {},
        orcamento: {},
        orcamentos: [],
        proposta: {},
        fotos: [],
        videos: [],
        produtos: [],
        tarefas: [],
        envolvidos: [],
        viatura: [],
        pt_planejamento: [],
        pt_epis: [],
        pt_antes: [],
        pt_depois: [],
        pt_responsavel_id: "",
        pt_data_aprovacao: "",
        ip1: true,
        ip2: true,
        ip3: true,
        ip4: true,
        if1: true,
        if2: true,
        if3: true,
        if4: true,
        endereco: "",
        lat: "",
        long: "",
        le_data: "",
        le_instalacao: "",
        le_ponto_medicao: "Rede Interna",
        le_gas: "Gás Natural",
        le_teste1_casa: "",
        le_teste1_complemento: "",
        le_teste1_duracao: "",
        le_teste1_mmca: "",
        le_teste1_kgf: "",
        le_teste1_mmcab: "",
        le_teste1_kgfb: "",
        le_teste1_aprovado: true,
        le_teste2_gas: "",
        le_teste2_casa: "",
        le_teste2_complemento: "",
        le_teste2_duracao: "",
        le_teste2_mmca: "",
        le_teste2_kgf: "",
        le_teste2_mmcab: "",
        le_teste2_kgfb: "",
        le_teste2_aprovado: true,
        le_aprovado: true,
        le_responsavel_id: "",
        le_dados: "",
        equipamentosUtilizados: [],
        revisoes: [],
        documento_assinado: "",
        revisao_aprovada: null,
        vistoria_realizada: false,
        vistoria_aprovada: false,
        tipo: "1",
        cnpj: "",
        razao_social: "",
        ie: "",
        responsavel: "",
        cpf: "",
        rg: "",
        email: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        isometrico: "",
        bairro: "",
        cidade: "",
        estado: "",
        referencia: "",
        mesmo_cliente: false,
        caracteristicas: [],
        isometricos: "",
        aprovacao_kitgas: 0,
        aprovacao_comgas: 0,
        comprovante_pagamento: "",
        hospital: "",
        endereco_hospital: "",
        telefone_hospital: ""
      };
    },
    totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        let response = JSON.parse(xhr.response);
        if (Array.isArray(response)) {
          response.forEach(item => {
            this.os.fotos.push({ foto: item, legenda: "", ordem: "" });
          });
        } else {
          this.os.fotos.push({ foto: xhr.response, legenda: "", ordem: "" });
        }
        this.progress = 0;
      }
    },
    destroyFoto(index, indexFoto) {
      this.$swal({
        title: "Atenção",
        text: `excluir uma foto é uma operação irreversível`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        if (!this.os.fotos[indexFoto].id) {
          this.os.fotos.splice(indexFoto, 1);
          window.Materialize.toast("Foto excluída!", 4000);
        } else {
          http
            .delete(`os/foto/${this.os.fotos[indexFoto].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast("Foto excluída!", 4000);
              this.os.fotos.splice(indexFoto, 1);
            });
        }
      });
    },
    totalProgressIsometrico(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    completeIsometrico(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute("id", xhr.response.id);
        this.os.isometricos = xhr.response;
        this.progress2 = 0;
      }
    },
    destroyIsometrico() {
      this.$swal({
        title: "Atenção",
        text: `deseja excluir a imagem?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        this.os.isometricos = "";
      });
    },
    totalProgressPagamento(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    completePagamento(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute("id", xhr.response.id);
        this.os.comprovante_pagamento = xhr.response;
        this.progress2 = 0;
      }
    },
    destroyPagamento() {
      this.$swal({
        title: "Atenção",
        text: `deseja excluir a imagem?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        this.os.comprovante_pagamento = "";
      });
    },
    destroyVideo(index, indexVideo) {
      this.$swal({
        title: "Atenção",
        text: `excluir uma video é uma operação irreversível`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        if (!this.os.videos[indexVideo].id) {
          this.os.videos.splice(indexVideo, 1);
          window.Materialize.toast("Video excluído!", 4000);
        } else {
          http
            .delete(`os/video/${this.os.videos[indexVideo].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast("Video excluído!", 4000);
              this.os.videos.splice(indexVideo, 1);
            });
        }
      });
    },
    addVideo() {
      if (this.video) {
        this.os.videos.push({
          video: this.video
        });
        this.video = "";
        setTimeout(function() {
          window.Materialize.updateTextFields();
        }, 300);
      }
    },
    totalProgress2(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete2(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.os.documento_assinado = xhr.response;
        this.progress = 0;
      }
    },
    onSelectProduto(item) {
      if (item) {
        var viaturaId = null;
        if (this.viatura) {
          viaturaId = this.viatura.id;
        }
        const produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_venda,
          qtd: 1,
          viatura_id: viaturaId
        };
        this.addProduto(produto);
      }
    },
    async addProduto(produto) {
      if (typeof this.os.produtos === "undefined") {
        this.os.produtos = [];
      }
      await this.os.produtos.push(produto);
      setTimeout(function() {
        window.Materialize.updateTextFields();
      }, 0);
    },
    destroyProduto(indexProduto) {
      this.$swal({
        title: "Atenção",
        text: `excluir um Produto é uma operação irreversível e vai restabelecer estoques nas viaturas de origem`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        if (!this.os.produtos[indexProduto].id) {
          this.os.produtos.splice(indexProduto, 1);
          window.Materialize.toast("Produto excluído!", 4000);
        } else {
          http
            .delete(`os/produto/${this.os.produtos[indexProduto].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast("Produto excluído!", 4000);
              this.os.produtos.splice(indexProduto, 1);
            });
        }
      });
    },
    destroyTarefa(indexTarefa) {
      this.$swal({
        title: "Atenção",
        text: `excluir um tarefa é uma operação irreversível e vai restabelecer estoques nas viaturas de origem`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        if (!this.os.tarefas[indexTarefa].id) {
          this.os.tarefas.splice(indexTarefa, 1);
          window.Materialize.toast("Tarefa excluído!", 4000);
        } else {
          http
            .delete(`tarefas/${this.os.tarefas[indexTarefa].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast("Tarefa excluído!", 4000);
              this.os.tarefas.splice(indexTarefa, 1);
            });
        }
      });
    },
    destroyHistorico(indexRegistro) {
      this.$swal({
        title: "Atenção",
        text: `excluir um registro é uma operação irreversível`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(() => {
        if (!this.os.historico[indexRegistro].id) {
          this.os.historico.splice(indexRegistro, 1);
          window.Materialize.toast("Registro excluído!", 4000);
        } else {
          http
            .delete(
              `orcamentos/historico/${this.os.historico[indexRegistro].id}`
            )
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast("Registro excluído!", 4000);
              this.os.historico.splice(indexRegistro, 1);
            });
        }
      });
    },
    // async procurarHospitais() {
    //   const { data } = await http.get(`os/anexo-emergencia/${this.os.id}`);
    //   this.hospitais = data;
    // },
    async selectHospital() {
      this.os.hospital = await this.hospital.name;
      this.os.endereco_hospital = await this.hospital.vicinity;
      this.os.telefone_hospital = await this.hospital.phone;
      await window.Materialize.updateTextFields();
    },
    getAddressData(addressData, placeResultData, id) {
      this.os.endereco = placeResultData.formatted_address;
      this.os.lat = addressData.latitude;
      this.os.long = addressData.longitude;
    },
    addTarefa() {
      this.os.tarefas.push({
        status_id: 1,
        usuarios: []
      });
      setTimeout(function() {
        window.Materialize.updateTextFields();
      }, 300);
    },
    addHistorico() {
      this.os.historico.push({
        data: this.historico.data,
        usuario: this.historico.usuario,
        conteudo: this.historico.conteudo
      });
      this.historico.conteudo = "";
      setTimeout(function() {
        window.Materialize.updateTextFields();
      }, 300);
    },
    chunkArray(myArray, chunkSize) {
      let index = 0;
      let arrayLength = myArray.length;
      let tempArray = [];
      if (arrayLength > chunkSize) {
        for (index = 0; index < arrayLength; index += chunkSize) {
          let myChunk = myArray.slice(index, index + chunkSize);
          // Do something if you want with the group
          tempArray.push(myChunk);
        }
      } else {
        tempArray.push(myArray);
      }
      return tempArray;
    }
  },
  computed: {
    ...mapState(["loading"]),
    ...mapGetters(["permissoes"]),
    api_url() {
      return process.env.UPLOADS_URL;
    },
    url_app() {
      return process.env.API_URL;
    },
    usuarioEnvolvidos: {
      get() {
        return this.usuarios.filter(option =>
          this.os.envolvidos.includes(option.id)
        );
      },
      set(newSelectedOptions) {
        this.os.envolvidos = newSelectedOptions.map(option => option.id);
      }
    },
    osEquipamentos: {
      get() {
        return this.equipamentos.filter(option =>
          this.os.equipamentosUtilizados.includes(option.id)
        );
      },
      set(newSelectedOptions) {
        this.os.equipamentosUtilizados = newSelectedOptions.map(
          option => option.id
        );
      }
    }
  }
};
</script>

<template>
  <div>
    <form>
      <div class="row">
        <div class="col s12 m10 offset-m1">
          <ul class="collapsible popout" data-collapsible="accordion">
            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">people</i> Informações Gerais
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="input-field col s12 m2">
                    <input
                      name="orcamento"
                      id="orcamento"
                      type="text"
                      :value="`#${os.orcamento.id}`"
                      disabled
                    />
                    <label for="orcamento">Orçamento</label>
                  </div>

                  <div class="col s12 m6">
                    <label for="responsavel_id">*Responsável Técnico</label>
                    <select
                      name="responsavel_id"
                      id="responsavel_id"
                      v-model="os.responsavel_id"
                    >
                      <option
                        v-for="responsavel in usuarios"
                        :value="responsavel.id"
                        >{{ responsavel.nome_completo }}
                      </option>
                    </select>
                    <small class="red-text">{{
                      errors.first("responsavel_id")
                    }}</small>
                  </div>

                  <div class="input-field col s12 m4">
                    <input
                      name="apartamento"
                      id="apartamento"
                      type="text"
                      v-model="os.apartamento"
                    />
                    <label for="apartamento"
                      >Referência (Bloco - Apartamento)</label
                    >
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input
                      name="medidor"
                      id="medidor"
                      type="text"
                      v-model="os.medidor"
                    />
                    <label for="medidor">Medidor de Gás</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input
                      name="medidor_marca"
                      id="medidor_marca"
                      type="text"
                      v-model="os.medidor_marca"
                    />
                    <label for="medidor_marca">Marca do Medidor</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input
                      name="medidor_numero"
                      id="medidor_numero"
                      type="text"
                      v-model="os.medidor_numero"
                    />
                    <label for="medidor_numero">Número do Medidor</label>
                  </div>

                  <div class="input-field col s12 m3">
                    <input
                      name="medidor_leitura"
                      id="medidor_leitura"
                      type="text"
                      v-model="os.medidor_leitura"
                    />
                    <label for="medidor_leitura">Leitura do Medidor</label>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m4">
                    <input
                      name="valor"
                      id="valor"
                      type="number"
                      step="any"
                      min="0"
                      v-model="os.valor"
                    />
                    <label for="valor">*R$ da Obra</label>
                  </div>

                  <div class="input-field col s12 m4">
                    <i class="material-icons prefix">event</i>
                    <input
                      name="inicio"
                      id="icon_inicio"
                      type="date"
                      v-model="os.inicio"
                      :data-value="os.inicio"
                    />
                    <label for="icon_inicio" class="active"
                      >Data de Início</label
                    >
                    <small class="red-text">{{ errors.first("inicio") }}</small>
                  </div>

                  <div class="input-field col s12 m4">
                    <input
                      name="tempo_execucao"
                      id="tempo_execucao"
                      type="number"
                      v-model="os.tempo_execucao"
                    />
                    <label for="tempo_execucao"
                      >Tempo de Execução (horas)</label
                    >
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">assignment</i> Descrição dos Serviços
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Descrição</label>
                    <quill-editor
                      ref="os.descricao"
                      v-model="os.descricao"
                      :options="editorDescricao"
                    >
                    </quill-editor>
                    <small class="red-text">{{
                      errors.first("descricao")
                    }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Dificuldades Encontradas</label>
                    <quill-editor
                      ref="os.dificuldades"
                      v-model="os.dificuldades"
                      :options="editorDificuldades"
                    >
                    </quill-editor>
                    <small class="red-text">{{
                      errors.first("dificuldades")
                    }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <!-- quill-editor -->
                    <label>Solução Proposta</label>
                    <quill-editor
                      ref="os.solucao"
                      v-model="os.solucao"
                      :options="editorSolucao"
                    >
                    </quill-editor>
                    <small class="red-text">{{
                      errors.first("solucao")
                    }}</small>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">assignment_turned_in</i> Lista de
                Materiais
              </div>
              <div class="collapsible-body">
                <div class="col s12">
                  <div class="row">
                    <div class="input-field col s12">
                      <list-select
                        :list="produtos"
                        option-value="id"
                        option-text="produto"
                        :selected-item="item"
                        placeholder="Adicionar Produto"
                        @select="onSelectProduto"
                      >
                      </list-select>
                    </div>
                  </div>

                  <div
                    class="row"
                    v-show="os.produtos && os.produtos.length > 0"
                  >
                    <div class="col s12">
                      <table class="responsive-table bordered highlight">
                        <tr>
                          <th>Materiais Utilizados</th>
                          <th>Qtd</th>
                          <th>Valor</th>
                          <th>Valor Total</th>
                          <th class="right-align">Excluir</th>
                        </tr>
                        <tr v-for="(produto, indexProduto) in os.produtos">
                          <td>
                            <p>
                              {{
                                produto.produto ? produto.produto.produto : "-"
                              }}
                            </p>
                          </td>
                          <td>
                            <input
                              type="number"
                              :id="`qtdProduto${indexProduto}`"
                              v-model="produto.qtd"
                              min="1"
                              style="margin-bottom: 0"
                              :readonly="produto.hasOwnProperty('id')"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              :id="`valorProduto${indexProduto}`"
                              v-model="produto.valor"
                              min="1"
                              style="margin-bottom: 0"
                              :readonly="produto.hasOwnProperty('id')"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              :id="`valorTotalProduto${indexProduto}`"
                              :value="produto.valor * produto.qtd"
                              style="margin-bottom: 0"
                              readonly
                            />
                          </td>
                          <td>
                            <div class="right-align">
                              <a
                                href="#"
                                @click.prevent="destroyProduto(indexProduto)"
                              >
                                <i class="material-icons red-text"
                                  >delete_forever</i
                                >
                              </a>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <br clear="all" />
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">list</i> Permissões de Trabalho
              </div>
              <div class="collapsible-body">
                <div class="col s12">
                  <div class="row">
                    <div class="col s12">
                      <table class="responsive-table bordered highlight">
                        <thead>
                          <tr>
                            <th>Procedimento</th>
                            <th>Item</th>
                            <th>Status</th>
                          </tr>
                          <tr>
                            <td>Planejamento da Tarefa</td>
                            <td>Gerador de Calor ou Faísca</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas[
                                    'Gerador de Calor ou Faísca'
                                  ]
                                "
                              >
                                <option value="Gerador de Calor ou Faísca___-"
                                  >Selecione</option
                                >
                                <option value="Gerador de Calor ou Faísca___C"
                                  >Conforme</option
                                >
                                <option value="Gerador de Calor ou Faísca___NC"
                                  >Não Conforme</option
                                >
                                <option value="Gerador de Calor ou Faísca___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Planejamento da Tarefa</td>
                            <td>Produtos Perigosos</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Produtos Perigosos']
                                "
                              >
                                <option value="Produtos Perigosos___-"
                                  >Selecione</option
                                >
                                <option value="Produtos Perigosos___C"
                                  >Conforme</option
                                >
                                <option value="Produtos Perigosos___NC"
                                  >Não Conforme</option
                                >
                                <option value="Produtos Perigosos___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Aparelho Respiratório</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Aparelho Respiratório']
                                "
                              >
                                <option value="Aparelho Respiratório___-"
                                  >Selecione</option
                                >
                                <option value="Aparelho Respiratório___C"
                                  >Conforme</option
                                >
                                <option value="Aparelho Respiratório___NC"
                                  >Não Conforme</option
                                >
                                <option value="Aparelho Respiratório___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Botina</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="os.caracteristicas['Botina']"
                              >
                                <option value="Botina___-">Selecione</option>
                                <option value="Botina___C">Conforme</option>
                                <option value="Botina___NC"
                                  >Não Conforme</option
                                >
                                <option value="Botina___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Capacete</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="os.caracteristicas['Capacete']"
                              >
                                <option value="Capacete___-">Selecione</option>
                                <option value="Capacete___C">Conforme</option>
                                <option value="Capacete___NC"
                                  >Não Conforme</option
                                >
                                <option value="Capacete___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Luvas</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="os.caracteristicas['Luvas']"
                              >
                                <option value="Luvas___-">Selecione</option>
                                <option value="Luvas___C">Conforme</option>
                                <option value="Luvas___NC">Não Conforme</option>
                                <option value="Luvas___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Óculos de Proteção</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Óculos de Proteção']
                                "
                              >
                                <option value="Óculos de Proteção___-"
                                  >Selecione</option
                                >
                                <option value="Óculos de Proteção___C"
                                  >Conforme</option
                                >
                                <option value="Óculos de Proteção___NC"
                                  >Não Conforme</option
                                >
                                <option value="Óculos de Proteção___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Protetor Auricular</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Protetor Auricular']
                                "
                              >
                                <option value="Protetor Auricular___-"
                                  >Selecione</option
                                >
                                <option value="Protetor Auricular___C"
                                  >Conforme</option
                                >
                                <option value="Protetor Auricular___NC"
                                  >Não Conforme</option
                                >
                                <option value="Protetor Auricular___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>EPI's Obrigatórios</td>
                            <td>Uniforme Completo</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Uniforme Completo']
                                "
                              >
                                <option value="Uniforme Completo___-"
                                  >Selecione</option
                                >
                                <option value="Uniforme Completo___C"
                                  >Conforme</option
                                >
                                <option value="Uniforme Completo___NC"
                                  >Não Conforme</option
                                >
                                <option value="Uniforme Completo___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Avaliar Explosividade = 0%</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas[
                                    'Avaliar Explosividade = 0%'
                                  ]
                                "
                              >
                                <option value="Avaliar Explosividade = 0%___-"
                                  >Selecione</option
                                >
                                <option value="Avaliar Explosividade = 0%___C"
                                  >Conforme</option
                                >
                                <option value="Avaliar Explosividade = 0%___NC"
                                  >Não Conforme</option
                                >
                                <option value="Avaliar Explosividade = 0%___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Bloquear Válvulas</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Bloquear Válvulas']
                                "
                              >
                                <option value="Bloquear Válvulas___-"
                                  >Selecione</option
                                >
                                <option value="Bloquear Válvulas___C"
                                  >Conforme</option
                                >
                                <option value="Bloquear Válvulas___NC"
                                  >Não Conforme</option
                                >
                                <option value="Bloquear Válvulas___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Constatar Ausência de Tensão</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas[
                                    'Constatar Ausência de Tensão'
                                  ]
                                "
                              >
                                <option value="Constatar Ausência de Tensão___-"
                                  >Selecione</option
                                >
                                <option value="Constatar Ausência de Tensão___C"
                                  >Conforme</option
                                >
                                <option
                                  value="Constatar Ausência de Tensão___NC"
                                  >Não Conforme</option
                                >
                                <option
                                  value="Constatar Ausência de Tensão___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Isolar a Área</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="os.caracteristicas['Isolar a Área']"
                              >
                                <option value="Isolar a Área___-"
                                  >Selecione</option
                                >
                                <option value="Isolar a Área___C"
                                  >Conforme</option
                                >
                                <option value="Isolar a Área___NC"
                                  >Não Conforme</option
                                >
                                <option value="Isolar a Área___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Proteger Riscos Vizinhos e Equip.</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas[
                                    'Proteger Riscos Vizinhos e Equip.'
                                  ]
                                "
                              >
                                <option
                                  value="Proteger Riscos Vizinhos e Equip.___-"
                                  >Selecione</option
                                >
                                <option
                                  value="Proteger Riscos Vizinhos e Equip.___C"
                                  >Conforme</option
                                >
                                <option
                                  value="Proteger Riscos Vizinhos e Equip.___NC"
                                  >Não Conforme</option
                                >
                                <option
                                  value="Proteger Riscos Vizinhos e Equip.___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências antes de Iniciar o Serviço</td>
                            <td>Sinalizar Área e Equipamentos</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas[
                                    'Sinalizar Área e Equipamentos'
                                  ]
                                "
                              >
                                <option
                                  value="Sinalizar Área e Equipamentos___-"
                                  >Selecione</option
                                >
                                <option
                                  value="Sinalizar Área e Equipamentos___C"
                                  >Conforme</option
                                >
                                <option
                                  value="Sinalizar Área e Equipamentos___NC"
                                  >Não Conforme</option
                                >
                                <option
                                  value="Sinalizar Área e Equipamentos___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências ao Finalizar o Serviço</td>
                            <td>Limpar o Local</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="os.caracteristicas['Limpar o Local']"
                              >
                                <option value="Limpar o Local___-"
                                  >Selecione</option
                                >
                                <option value="Limpar o Local___C"
                                  >Conforme</option
                                >
                                <option value="Limpar o Local___NC"
                                  >Não Conforme</option
                                >
                                <option value="Limpar o Local___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências ao Finalizar o Serviço</td>
                            <td>Retirar Bloqueios</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Retirar Bloqueios']
                                "
                              >
                                <option value="Retirar Bloqueios___-"
                                  >Selecione</option
                                >
                                <option value="Retirar Bloqueios___C"
                                  >Conforme</option
                                >
                                <option value="Retirar Bloqueios___NC"
                                  >Não Conforme</option
                                >
                                <option value="Retirar Bloqueios___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências ao Finalizar o Serviço</td>
                            <td>Retirar Isolamentos</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Retirar Isolamentos']
                                "
                              >
                                <option value="Retirar Isolamentos___-"
                                  >Selecione</option
                                >
                                <option value="Retirar Isolamentos___C"
                                  >Conforme</option
                                >
                                <option value="Retirar Isolamentos___NC"
                                  >Não Conforme</option
                                >
                                <option value="Retirar Isolamentos___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Providências ao Finalizar o Serviço</td>
                            <td>Guardar Ferramentas</td>
                            <td>
                              <select
                                name="caracteristicas"
                                v-model="
                                  os.caracteristicas['Guardar Ferramentas']
                                "
                              >
                                <option value="Guardar Ferramentas___-"
                                  >Selecione</option
                                >
                                <option value="Guardar Ferramentas___C"
                                  >Conforme</option
                                >
                                <option value="Guardar Ferramentas___NC"
                                  >Não Conforme</option
                                >
                                <option value="Guardar Ferramentas___NA"
                                  >Não Aplicável</option
                                >
                              </select>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s8">
                      <label>Usuários Envolvidos na OS</label>
                      <multiselect
                        multiple
                        placeholder="Selecione"
                        :closeOnSelect="false"
                        v-model="usuarioEnvolvidos"
                        label="nome_completo"
                        track-by="id"
                        :options="usuarios"
                      ></multiselect>
                    </div>

                    <div class="input-field col s12 m4">
                      <i class="material-icons prefix">event</i>
                      <input
                        name="pt_data_aprovacao"
                        id="icon_pt_data_aprovacao"
                        type="date"
                        v-model="os.pt_data_aprovacao"
                        :data-value="os.pt_data_aprovacao"
                      />
                      <label for="icon_pt_data_aprovacao" class="active"
                        >Data de Aprovação</label
                      >
                      <small class="red-text">{{
                        errors.first("pt_data_aprovacao")
                      }}</small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <p><strong>Acompanhamento da Obra</strong></p>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12 m6">
                    <p>Inspeção Pré Obra</p>
                    <table>
                      <tr>
                        <td>Adequação do local para início da obra</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.ip1" />
                              <span class="lever"></span>
                              {{ os.ip1 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Execução da obra</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.ip2" />
                              <span class="lever"></span>
                              {{ os.ip2 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Preenchimento de documentação</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.ip3" />
                              <span class="lever"></span>
                              {{ os.ip3 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Conhecimento das regras internas</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.ip4" />
                              <span class="lever"></span>
                              {{ os.ip4 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="col s12 m6">
                    <p>Inspeção Final</p>
                    <table>
                      <tr>
                        <td>Inspeção visual da obra</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.if1" />
                              <span class="lever"></span>
                              {{ os.if1 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Inspeção do servico executado</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.if2" />
                              <span class="lever"></span>
                              {{ os.if2 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Finalização da obra</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.if3" />
                              <span class="lever"></span>
                              {{ os.if3 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Adequação do local para entrega da obra</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" v-model="os.if4" />
                              <span class="lever"></span>
                              {{ os.if4 ? "Adequado" : "Inadequado" }}
                            </label>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="row">
                  <div class="col s6">
                    <label>Aprovação KitGás</label>
                    <select v-model="os.aprovacao_kitgas">
                      <option :value="0">Selecione</option>
                      <option :value="1">Sim</option>
                      <option :value="2">Não</option>
                    </select>
                  </div>
                  <div class="col s6">
                    <label>Aprovação Com Gás</label>
                    <select v-model="os.aprovacao_comgas">
                      <option :value="0">Selecione</option>
                      <option :value="1">Sim</option>
                      <option :value="2">Não</option>
                    </select>
                  </div>
                </div>

                <br clear="all" />
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">receipt</i> Laudo de Estanqueidade
              </div>
              <div class="collapsible-body">
                <div class="col s12">
                  <div class="row">
                    <div class="input-field col s12 m6">
                      <i class="material-icons prefix">event</i>
                      <input
                        name="le_data"
                        id="icon_le_data"
                        type="date"
                        v-model="os.le_data"
                        :data-value="os.le_data"
                      />
                      <label for="icon_le_data" class="active"
                        >Data do Teste</label
                      >
                      <small class="red-text">{{
                        errors.first("le_data")
                      }}</small>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        name="le_instalacao"
                        id="le_instalacao"
                        type="text"
                        v-model="os.le_instalacao"
                      />
                      <label for="le_instalacao">Tipo de Instalação</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12 m4">
                      <label for="le_ponto_medicao">Ponto de Medição</label>
                      <select
                        name="le_ponto_medicao"
                        id="le_ponto_medicao"
                        v-model="os.le_ponto_medicao"
                      >
                        <option value="Rede Interna">Rede Interna</option>
                        <option value="Rede e Prumada Coletiva"
                          >Rede e Prumada Coletiva</option
                        >
                        <option value="Rede e Prumada Individual"
                          >Rede e Prumada Individual</option
                        >
                        <option value="Ramal de Entrada"
                          >Ramal de Entrada</option
                        >
                        <option value="Ramal Interno">Ramal Interno</option>
                      </select>
                      <small class="red-text">{{
                        errors.first("le_ponto_medicao")
                      }}</small>
                    </div>

                    <div class="col s12 m4">
                      <label for="le_gas">Tipo de Gás</label>
                      <select name="le_gas" id="le_gas" v-model="os.le_gas">
                        <option value="Gás Natural">Gás Natural</option>
                        <option value="Gás L.P MMCA">Gás L.P MMCA</option>
                        <option value="Gás L.P KGF/cm2">Gás L.P KGF/cm2</option>
                      </select>
                      <small class="red-text">{{
                        errors.first("le_gas")
                      }}</small>
                    </div>

                    <div class="col s12 m4">
                      <label>Equipamentos Utilizados</label>
                      <multiselect
                        multiple
                        placeholder="Selecione"
                        :closeOnSelect="false"
                        v-model="osEquipamentos"
                        label="equipamento"
                        track-by="id"
                        :options="equipamentos"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12"><strong>Teste 1</strong></div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste1_casa"
                        id="le_teste1_casa"
                        type="text"
                        v-model="os.le_teste1_casa"
                      />
                      <label for="le_teste1_casa">N. Casa</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste1_complemento"
                        id="le_teste1_complemento"
                        type="text"
                        v-model="os.le_teste1_complemento"
                      />
                      <label for="le_teste1_complemento">Compl.</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste1_duracao"
                        id="le_teste1_duracao"
                        type="text"
                        v-model="os.le_teste1_duracao"
                      />
                      <label for="le_teste1_duracao">Duração (min)</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="
                        os.le_gas === 'Gás Natural' ||
                          os.le_gas === 'Gás L.P MMCA'
                      "
                    >
                      <input
                        name="le_teste1_mmca"
                        id="le_teste1_mmca"
                        type="text"
                        v-model="os.le_teste1_mmca"
                      />
                      <label for="le_teste1_mmca">MMCA Pressão</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="
                        os.le_gas === 'Gás Natural' ||
                          os.le_gas === 'Gás L.P MMCA'
                      "
                    >
                      <input
                        name="le_teste1_mmcab"
                        id="le_teste1_mmcab"
                        type="text"
                        v-model="os.le_teste1_mmcab"
                      />
                      <label for="le_teste1_mmcab">MMCA Perda</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="os.le_gas === 'Gás L.P KGF/cm2'"
                    >
                      <input
                        name="le_teste1_kgf"
                        id="le_teste1_kgf"
                        type="text"
                        v-model="os.le_teste1_kgf"
                      />
                      <label for="le_teste1_kgf">KGF/cm2</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="os.le_gas === 'Gás L.P KGF/cm2'"
                    >
                      <input
                        name="le_teste1_kgfb"
                        id="le_teste1_kgfb"
                        type="text"
                        v-model="os.le_teste1_kgfb"
                      />
                      <label for="le_teste1_kgfb">KGF/cm2 Perda</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <div class="switch">
                        <label>
                          <input
                            type="checkbox"
                            v-model="os.le_teste1_aprovado"
                          />
                          <span class="lever"></span>
                          {{ os.le_teste1_aprovado ? "Aprovado" : "Reprovado" }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12"><strong>Teste 2</strong></div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste2_casa"
                        id="le_teste2_casa"
                        type="text"
                        v-model="os.le_teste2_casa"
                      />
                      <label for="le_teste2_casa">N. Casa</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste2_complemento"
                        id="le_teste2_complemento"
                        type="text"
                        v-model="os.le_teste2_complemento"
                      />
                      <label for="le_teste2_complemento">Compl.</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <input
                        name="le_teste2_duracao"
                        id="le_teste2_duracao"
                        type="text"
                        v-model="os.le_teste2_duracao"
                      />
                      <label for="le_teste2_duracao">Duração (min)</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="
                        os.le_gas === 'Gás Natural' ||
                          os.le_gas === 'Gás L.P MMCA'
                      "
                    >
                      <input
                        name="le_teste2_mmca"
                        id="le_teste2_mmca"
                        type="text"
                        v-model="os.le_teste2_mmca"
                      />
                      <label for="le_teste2_mmca">MMCA Pressão</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="
                        os.le_gas === 'Gás Natural' ||
                          os.le_gas === 'Gás L.P MMCA'
                      "
                    >
                      <input
                        name="le_teste2_mmcab"
                        id="le_teste2_mmcab"
                        type="text"
                        v-model="os.le_teste2_mmcab"
                      />
                      <label for="le_teste2_mmcab">MMCA Perda</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="os.le_gas === 'Gás L.P KGF/cm2'"
                    >
                      <input
                        name="le_teste2_kgf"
                        id="le_teste2_kgf"
                        type="text"
                        v-model="os.le_teste2_kgf"
                      />
                      <label for="le_teste2_kgf">KGF/cm2</label>
                    </div>

                    <div
                      class="input-field col s12 m2"
                      v-show="os.le_gas === 'Gás L.P KGF/cm2'"
                    >
                      <input
                        name="le_teste2_kgfb"
                        id="le_teste2_kgfb"
                        type="text"
                        v-model="os.le_teste2_kgfb"
                      />
                      <label for="le_teste2_kgfb">KGF/cm2 Perda</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <div class="switch">
                        <label>
                          <input
                            type="checkbox"
                            v-model="os.le_teste2_aprovado"
                          />
                          <span class="lever"></span>
                          {{ os.le_teste2_aprovado ? "Aprovado" : "Reprovado" }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12">
                      <textarea
                        name="le_dados"
                        id="le_dados"
                        type="text"
                        v-model="os.le_dados"
                        class="materialize-textarea"
                      ></textarea>
                      <label for="le_dados">Dados Técnicos</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12">
                      <div class="switch">
                        <label class="right">
                          <input type="checkbox" v-model="os.le_aprovado" />
                          <span class="lever"></span>
                          {{
                            os.le_aprovado
                              ? "Teste Aprovado"
                              : "Teste Reprovado"
                          }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <br clear="all" />
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3 ">
                <i class="material-icons">local_hospital</i> Anexo de Emergência
              </div>
              <div class="collapsible-body">
                <div class="col s12">
                  <!--<div class="row">
                    <div class="col s12">
                      <button
                        type="button"
                        @click.prevent="procurarHospitais"
                        class="waves-effect waves-light btn"
                      >
                        Procurar Hospitais
                      </button>
                    </div>
                  </div>-->

                  <div class="row" v-show="hospitais.length">
                    <div class="col s12">
                      <label>Hospital</label>
                      <select v-model="hospital" @change="selectHospital()">
                        <option :value="{}">Selecione</option>
                        <option v-for="row in hospitais" :value="row"
                          >{{ row.label }} - {{ row.name }}, {{ row.vicinity }}</option
                        >
                      </select>
                      <small class="red-text">{{
                        errors.first("status_id")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m4">
                      <input
                        name="hospital"
                        id="hospital"
                        type="text"
                        v-model="os.hospital"
                      />
                      <label for="hospital">Hospital</label>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        name="endereco_hospital"
                        id="endereco_hospital"
                        type="text"
                        v-model="os.endereco_hospital"
                      />
                      <label for="endereco_hospital">Endereço</label>
                    </div>

                    <div class="input-field col s12 m2">
                      <input
                        name="telefone_hospital"
                        id="telefone_hospital"
                        type="text"
                        v-model="os.telefone_hospital"
                      />
                      <label for="telefone_hospital">Telefone</label>
                    </div>
                  </div>
                </div>

                <br clear="all" />
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">add_a_photo</i> Isométrico
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s12">
                    <vue-clip
                      :options="options3"
                      :on-complete="completeIsometrico"
                      :on-total-progress="totalProgressIsometrico"
                    >
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div
                                  class="center-align"
                                  style="height: 100px; width: 100%;"
                                >
                                  <img
                                    v-if="os.isometricos"
                                    :src="`${api_url}/os/${os.isometricos}`"
                                    style="max-width: 90%; max-height: 80px;"
                                  />
                                  <div v-else>
                                    <img
                                      src="../../../assets/images/thumbupload.jpg"
                                      style="max-width: 90%; max-height: 50px;"
                                    />
                                    <br clear="all" />
                                    <small class="center-align"
                                      >clique para inserir uma imagem</small
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div
                                class="determinate"
                                :style="`width: ${progress2}%`"
                              ></div>
                            </div>
                            <div v-if="errorFile2" class="center-align">
                              Tipo de arquivo inválido
                            </div>
                            <div v-if="os.isometricos" class="center-align">
                              <i
                                class="material-icons pointer"
                                @click.prevent="destroyIsometrico()"
                                >delete_forever</i
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">add_a_photo</i> Fotos
              </div>
              <div class="collapsible-body">
                <div class="row" v-for="fotos in chunkArray(os.fotos, 3)">
                  <div
                    class="col s12 m4 center-align"
                    v-for="(foto, indexFoto) in fotos"
                  >
                    <img
                      :src="`${api_url}/os/${foto.foto}`"
                      style="max-width: 90%; height: 150px;"
                      class="pointer center-align"
                    /><br />
                    <br />
                    <label :for="`legenda${indexFoto}`">Legenda</label>
                    <textarea
                      :name="`legenda{indexFoto}`"
                      :id="`legenda{indexFoto}`"
                      v-model="foto.legenda"
                      class="materialize-textarea"
                    ></textarea>
                    <a href="#" @click.prevent="destroyFoto(index, indexFoto)">
                      <i class="material-icons red-text">delete_forever</i>
                    </a>
                    <br clear="all" />
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <vue-clip
                      :options="options"
                      :on-complete="complete"
                      :on-total-progress="totalProgress"
                    >
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div class="center-align" style="width: 100%;">
                                  <p class="center-align">
                                    clique para inserir imagens
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div
                                class="determinate"
                                :style="`width: ${progress}%`"
                              ></div>
                            </div>
                            <div v-if="errorFile" class="center-align">
                              Tipo de arquivo inválido
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">video_library</i> Vídeos
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div
                    class="col s12 center-align"
                    v-for="(video, indexVideo) in os.videos"
                  >
                    <span v-html="video.video"></span>
                    <br />
                    <a
                      href="#"
                      @click.prevent="destroyVideo(index, indexVideo)"
                    >
                      <i class="material-icons red-text">delete_forever</i>
                    </a>
                    <br clear="all" />
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <label>Embed Vídeo</label>
                    <textarea
                      class="materialize-textarea"
                      v-model="video"
                    ></textarea>
                    <button
                      type="button"
                      @click.prevent="addVideo"
                      class="waves-effect waves-light btn"
                    >
                      Adicionar Vídeo
                    </button>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">edit</i> Documento Assinado
              </div>
              <div class="collapsible-body">
                <div class="row" v-show="os.documento_assinado">
                  <div class="col s12">
                    <a
                      :href="`${url_app}/os/${os.id}/download`"
                      class="blue-text"
                      target="_blank"
                    >
                      <i class="material-icons left">file_download</i> Baixar
                      Documento Assinado
                    </a>
                  </div>
                </div>

                <div class="row">
                  <div class="col s12">
                    <vue-clip
                      :options="options2"
                      :on-complete="complete2"
                      :on-total-progress="totalProgress2"
                    >
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div class="center-align" style="width: 100%;">
                                  <p class="center-align">
                                    clique para inserir o documento assinado
                                    pelo cliente
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div
                                class="determinate"
                                :style="`width: ${progress}%`"
                              ></div>
                            </div>
                            <div v-if="errorFile" class="center-align">
                              Tipo de arquivo inválido
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>
                  </div>
                </div>
              </div>
            </li>

            <li v-show="os.financeiro && os.financeiro.length > 0">
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">attach_money</i> Financeiro
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s12 m2" v-for="conta in os.financeiro">
                    <i
                      class="material-icons left green-text"
                      v-show="conta.pago"
                      >check</i
                    >
                    <i
                      class="material-icons left white-text"
                      v-show="!conta.pago"
                      >check</i
                    >
                    {{ formatDate(conta.vencimento) }}<br />
                    <strong>R$ {{ conta.valor_pago }}</strong
                    ><br /><br />
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">assessment</i> Revisão
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s12 m3">
                    <input
                      name="vistoria_realizada"
                      id="vistoria_realizada"
                      type="checkbox"
                      v-model="os.vistoria_realizada"
                    />
                    <label for="vistoria_realizada">Vistoria Realizada</label>
                  </div>

                  <div
                    class="col s12 m3"
                    v-show="os.vistoria_realizada === true"
                  >
                    <div class="switch">
                      <label style="display: inline-flex;">
                        Reprovado
                        <input type="checkbox" v-model="os.vistoria_aprovada" />
                        <span class="lever"></span>
                        Aprovado
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col s12 m6"
                    v-show="permissoes.indexOf('os.trocar-revisao') > -1"
                  >
                    <label for="revisao_id">Revisão</label>
                    <select
                      name="revisao_id"
                      id="revisao_id"
                      v-model="os.revisao_id"
                    >
                      <option v-for="revisao in revisoes" :value="revisao.id"
                        >{{ revisao.tipo }}
                      </option>
                    </select>
                  </div>

                  <div
                    class="input-field col s12 m6"
                    v-show="
                      permissoes.indexOf('os.trocar-revisao') > -1 ||
                        !os.revisoes.length
                    "
                  >
                    <button
                      type="button"
                      @click="adicionarRevisao"
                      class="btn waves-effect waves-light blue"
                    >
                      Iniciar
                    </button>
                  </div>
                </div>

                <div class="row" v-if="os.revisoes.length > 0">
                  <div class="col s12">
                    <table class="responsive-table bordered highlight">
                      <tr>
                        <th>Inspeção</th>
                        <th>Ordem</th>
                        <th></th>
                      </tr>
                      <tr v-for="(revisao, index) in os.revisoes">
                        <td>
                          {{
                            revisao && revisao.item && revisao.item.inspecao
                              ? revisao.item.inspecao
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            revisao && revisao.item && revisao.item.ordem
                              ? revisao.item.ordem
                              : "-"
                          }}
                        </td>
                        <td>
                          <select v-model="revisao.aprovado">
                            <option :value="1">Aprovado</option>
                            <option :value="0">Reprovado</option>
                            <option :value="2">Não aplicável</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col s12 m3"
                    v-show="os.revisoes && os.revisoes.length > 0"
                  >
                    <div class="col s12">
                      <select
                        name="revisao_aprovada"
                        id="revisao_aprovada"
                        v-model="os.revisao_aprovada"
                      >
                        <option :value="null"
                          >Selecione Status da Revisão</option
                        >
                        <option value="0">Reprovada</option>
                        <option value="1">Aprovada</option>
                        <option value="2">Cancelada</option>
                        <option value="3">Recusada Pelo Cliente</option>
                        <option value="4">Cliente Ausente</option>
                      </select>
                    </div>
                  </div>

                  <div
                    class="col s12 m3"
                    v-show="os.revisoes && os.revisoes.length > 0"
                  >
                    <div class="col s12">
                      <input
                        name="os.gerar_texto"
                        id="os.gerar_texto"
                        type="checkbox"
                        v-model="os.gerar_texto"
                      />
                      <label for="os.gerar_texto">Gerar Texto Revisão</label>
                    </div>
                  </div>

                  <div
                    class="col s12 m3"
                    v-show="os.revisoes && os.revisoes.length > 0"
                  >
                    <div class="col s12">
                      <input
                        name="orcamento_revisao"
                        id="orcamento_revisao"
                        type="checkbox"
                        v-model="os.gerar_orcamento"
                      />
                      <label for="orcamento_revisao">Gerar Orçamento</label>
                    </div>
                  </div>

                  <div class="col s12 m3" v-show="os.gerar_orcamento">
                    <div class="col s12">
                      <input
                        name="mesmo_cliente"
                        id="mesmo_cliente"
                        type="checkbox"
                        v-model="os.mesmo_cliente"
                      />
                      <label for="mesmo_cliente">Manter Cliente</label>
                    </div>
                  </div>
                </div>

                <div v-show="os.orcamentos.length">
                  <p>
                    <strong
                      >Os orçamentos abaixo foram gerados a partir dessa
                      OS</strong
                    >
                  </p>
                  <span v-for="orc in os.orcamentos"
                    ><router-link
                      :to="{ name: 'orcamentos.form', params: { id: orc.id } }"
                      >{{ orc.id }}</router-link
                    >,
                  </span>
                </div>

                <div v-show="os.gerar_orcamento && !os.mesmo_cliente">
                  <div class="row">
                    <div class="input-field col s12 m8">
                      <input
                        name="responsavel"
                        id="responsavel"
                        type="text"
                        v-model="os.responsavel"
                        v-validate="
                          os.gerar_orcamento && !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        :class="{ invalid: errors.has('responsavel') }"
                      />
                      <label for="responsavel">*Responsável</label>
                      <small class="red-text">{{
                        errors.first("responsavel")
                      }}</small>
                    </div>
                    <div class="col s12 m4">
                      <label for="tipo">*Tipo</label>
                      <select
                        name="tipo"
                        id="tipo"
                        v-validate="
                          os.gerar_orcamento && !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        data-vv-rules="required"
                        :class="{ invalid: errors.has('tipo') }"
                        v-model.number="os.tipo"
                      >
                        <option value="1">Pessoa Jurídica</option>
                        <option value="2">Pessoa Física</option>
                      </select>
                      <small class="red-text">{{ errors.first("tipo") }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m4">
                      <input
                        name="razao_social"
                        id="razao_social"
                        type="text"
                        v-model="os.razao_social"
                      />
                      <label for="razao_social">Razão Social</label>
                      <small class="red-text">{{
                        errors.first("razao_social")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m4" v-show="os.tipo === 1">
                      <input
                        name="cnpj"
                        id="cnpj"
                        type="text"
                        v-mask="'99.999.999/9999-99'"
                        v-validate="
                          os.gerar_orcamento &&
                          os.tipo === 1 &&
                          !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        data-vv-rules="required|min:18"
                        :class="{ invalid: errors.has('cnpj') }"
                        v-model="os.cnpj"
                      />
                      <label for="cnpj">CNPJ</label>
                      <small class="red-text">{{ errors.first("cnpj") }}</small>
                    </div>
                    <div class="input-field col s12 m4" v-show="os.tipo === 1">
                      <input
                        name="ie"
                        id="ie"
                        type="text"
                        :class="{ invalid: errors.has('ie') }"
                        v-model="os.ie"
                      />
                      <label for="ie">Inscrição Estadual</label>
                      <small class="red-text">{{ errors.first("ie") }}</small>
                    </div>
                    <div class="input-field col s12 m4" v-show="os.tipo === 2">
                      <input
                        name="cpf"
                        id="cpf"
                        type="text"
                        v-mask="'999.999.999-99'"
                        v-validate="
                          os.gerar_orcamento &&
                          os.tipo === 2 &&
                          !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        data-vv-rules="min:14"
                        :class="{ invalid: errors.has('cpf') }"
                        v-model="os.cpf"
                      />
                      <label for="cpf">*CPF</label>
                      <small class="red-text">{{ errors.first("cpf") }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m3">
                      <input
                        name="telefone"
                        id="telefone"
                        type="text"
                        v-mask="'(99) 99999999[9]'"
                        v-validate="
                          os.gerar_orcamento && !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        data-vv-rules="min:13"
                        :class="{ invalid: errors.has('telefone') }"
                        v-model="os.telefone"
                      />
                      <label for="telefone">Telefone</label>
                      <small class="red-text">{{
                        errors.first("telefone")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m3">
                      <input
                        name="telefone2"
                        id="telefone2"
                        type="text"
                        v-mask="'(99) 99999999[9]'"
                        v-validate
                        data-vv-rules="min:13"
                        :class="{ invalid: errors.has('telefone2') }"
                        v-model="os.telefone2"
                      />
                      <label for="telefone2">Telefone</label>
                      <small class="red-text">{{
                        errors.first("telefone2")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m3">
                      <input
                        name="telefone3"
                        id="telefone3"
                        type="text"
                        v-mask="'(99) 99999999[9]'"
                        v-validate
                        data-vv-rules="min:13"
                        :class="{ invalid: errors.has('telefone3') }"
                        v-model="os.telefone3"
                      />
                      <label for="telefone3">Telefone</label>
                      <small class="red-text">{{
                        errors.first("telefone3")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m3">
                      <input
                        name="email"
                        id="email"
                        type="text"
                        v-validate="
                          os.gerar_orcamento && !os.mesmo_cliente
                            ? 'required'
                            : ''
                        "
                        data-vv-rules="email"
                        :class="{ invalid: errors.has('email') }"
                        v-model="os.email"
                      />
                      <label for="email">E-mail</label>
                      <small class="red-text">{{
                        errors.first("email")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m3">
                      <input
                        name="cep"
                        id="cep"
                        type="text"
                        v-mask="'99999-999'"
                        v-validate
                        data-vv-rules="min:9"
                        :class="{ invalid: errors.has('cep') }"
                        @blur="setEndereco"
                        v-model="os.cep"
                      />
                      <label for="cep">CEP</label>
                      <small class="red-text">{{ errors.first("cep") }}</small>
                    </div>
                    <div class="input-field col s12 m5">
                      <input
                        name="logradouro"
                        id="logradouro"
                        type="text"
                        v-model="os.logradouro"
                      />
                      <label for="logradouro">Logradouro</label>
                      <small class="red-text">{{
                        errors.first("logradouro")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m2">
                      <input
                        name="numero"
                        id="numero"
                        type="text"
                        v-model="os.numero"
                      />
                      <label for="numero">Nº</label>
                      <small class="red-text">{{
                        errors.first("numero")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m2">
                      <input
                        name="complemento"
                        id="complemento"
                        type="text"
                        v-model="os.complemento"
                      />
                      <label for="complemento">Compl.</label>
                      <small class="red-text">{{
                        errors.first("complemento")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12 m5">
                      <input
                        name="bairro"
                        id="bairro"
                        type="text"
                        v-model="os.bairro"
                      />
                      <label for="bairro">Bairro</label>
                      <small class="red-text">{{
                        errors.first("bairro")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m5">
                      <input
                        name="cidade"
                        id="cidade"
                        type="text"
                        v-model="os.cidade"
                      />
                      <label for="cidade">Cidade</label>
                      <small class="red-text">{{
                        errors.first("cidade")
                      }}</small>
                    </div>
                    <div class="input-field col s12 m2">
                      <input
                        name="estado"
                        id="estado"
                        type="text"
                        v-model="os.estado"
                      />
                      <label for="estado">Estado</label>
                      <small class="red-text">{{
                        errors.first("estado")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12">
                      <input
                        name="referencia"
                        id="referencia"
                        type="text"
                        v-model="os.referencia"
                      />
                      <label for="referencia">Ponto de Referência</label>
                      <small class="red-text">{{
                        errors.first("referencia")
                      }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">alarm_on</i> Tarefas
              </div>
              <div class="collapsible-body">
                <div
                  v-for="(tarefa, indexTarefa) in os.tarefas"
                  class="z-depth-1"
                >
                  <div class="row">
                    <div class="input-field col s12 m7">
                      <input
                        name="tarefa"
                        type="text"
                        v-validate
                        data-vv-rules="required"
                        :class="{ invalid: errors.has('tarefa') }"
                        v-model="tarefa.tarefa"
                      />
                      <label>*Tarefa</label>
                      <small class="red-text">{{
                        errors.first("tarefa")
                      }}</small>
                    </div>

                    <div class="input-field col s12 m3">
                      <i class="material-icons prefix">event</i>
                      <input
                        name="dia"
                        type="date"
                        v-validate
                        data-vv-rules="required"
                        :class="{ invalid: errors.has('dia') }"
                        v-model="tarefa.dia"
                        :data-value="tarefa.dia"
                      />
                      <label class="active">*Prazo dia</label>
                      <small class="red-text">{{ errors.first("dia") }}</small>
                    </div>

                    <div class="input-field col s12 m2">
                      <i class="material-icons prefix">alarm</i>
                      <input
                        name="hora"
                        type="text"
                        :id="`hora${indexTarefa}`"
                        v-time
                        v-validate
                        data-vv-rules="required"
                        :class="{ invalid: errors.has('hora') }"
                        v-model="tarefa.hora"
                        :data-value="tarefa.hora"
                      />
                      <label :for="`hora${indexTarefa}`">*hora</label>
                      <small class="red-text">{{ errors.first("hora") }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12 m9">
                      <label>Usuários Envolvidos na Tarefa</label>
                      <multiselect
                        multiple
                        placeholder="Selecione"
                        v-model="tarefa.usuarios"
                        :closeOnSelect="false"
                        label="nome_completo"
                        track-by="id"
                        :options="usuarios"
                      ></multiselect>
                    </div>

                    <div class="col s12 m3">
                      <label>*Status</label>
                      <select
                        name="status_id"
                        v-validate
                        data-vv-rules="required"
                        v-model="tarefa.status_id"
                      >
                        <option value="1">Agendada</option>
                        <option value="2">Em execução</option>
                        <option value="3">Finalizada</option>
                      </select>
                      <small class="red-text">{{
                        errors.first("status_id")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12">
                      <textarea
                        name="descricao"
                        class="materialize-textarea"
                        v-model="tarefa.descricao"
                      ></textarea>
                      <label>Descrição</label>
                      <small class="red-text">{{
                        errors.first("descricao")
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12">
                      <a href="#" @click.prevent="destroyTarefa(indexTarefa)">
                        <i class="material-icons red-text right"
                          >delete_forever</i
                        >
                      </a>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 right-align">
                    <button
                      type="button"
                      class="waves-effect waves-light btn"
                      @click="addTarefa"
                    >
                      Adicionar Tarefa
                    </button>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">add_a_photo</i> Comprovante de Pagamento
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s12">
                    <vue-clip
                      :options="options4"
                      :on-complete="completePagamento"
                      :on-total-progress="totalProgressPagamento"
                    >
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div
                                  class="center-align"
                                  style="height: 100px; width: 100%;"
                                >
                                  <img
                                    v-if="os.comprovante_pagamento"
                                    :src="`${api_url}/os/${os.comprovante_pagamento}`"
                                    style="max-width: 90%; max-height: 80px;"
                                  />
                                  <div v-else>
                                    <img
                                      src="../../../assets/images/thumbupload.jpg"
                                      style="max-width: 90%; max-height: 50px;"
                                    />
                                    <br clear="all" />
                                    <small class="center-align"
                                      >clique para inserir uma imagem</small
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div
                                class="determinate"
                                :style="`width: ${progress2}%`"
                              ></div>
                            </div>
                            <div v-if="errorFile2" class="center-align">
                              Tipo de arquivo inválido
                            </div>
                            <div v-if="os.comprovante_pagamento" class="center-align">
                              <i
                                class="material-icons pointer"
                                @click.prevent="destroyPagamento()"
                                >delete_forever</i
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">history</i> Histórico
              </div>
              <div class="collapsible-body">
                <div class="z-depth-1">
                  <div class="row">
                    <div class="col s12">
                      <table>
                        <tr>
                          <th>Data</th>
                          <th>Usuário</th>
                          <th>Conteúdo</th>
                          <th class="center">Ação</th>
                        </tr>
                        <tr v-for="(registro, indexRegistro) in os.historico">
                          <td>{{ registro.data }}</td>
                          <td>
                            {{ registro.usuario ? registro.usuario.nome : "-" }}
                          </td>
                          <td>{{ registro.conteudo }}</td>
                          <td class="center">
                            <a
                              href="#"
                              @click.prevent="destroyHistorico(indexRegistro)"
                            >
                              <i class="material-icons red-text"
                                >delete_forever</i
                              >
                            </a>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12">
                      <textarea
                        name="historico_conteudo"
                        id="historico_conteudo"
                        type="text"
                        v-model="historico.conteudo"
                        class="materialize-textarea"
                        placeholder="Conteúdo"
                      ></textarea>
                      <label for="le_dados">Adicionar Registro</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="input-field col s12">
                      <button
                        type="button"
                        class="waves-effect waves-light btn"
                        @click="addHistorico"
                      >
                        Adicionar Registro
                      </button>
                      <br clear="all" />
                      <br clear="all" />
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <br clear="all" />
          <hr />
          <br clear="all" />

          <div class="row">
            <div class="col s12 m4">
              <label for="status_id">*Status</label>
              <select
                name="status_id"
                id="status_id"
                v-validate
                data-vv-rules="required"
                v-model="os.status_id"
              >
                <option v-for="status in status" :value="status.id">{{
                  status.status
                }}</option>
              </select>
              <small class="red-text">{{ errors.first("status_id") }}</small>
            </div>

            <div
              class="col s12 m3"
              v-show="os.financeiro && os.financeiro.length === 0"
            >
              <div class="input-field col s12">
                <input
                  name="lancar_financeiro"
                  id="lancar_financeiro"
                  type="checkbox"
                  v-model="lancar_financeiro"
                />
                <label for="lancar_financeiro">Lançar Financeiro</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <button
                type="button"
                @click.prevent="validate"
                class="waves-effect waves-light btn"
                :disabled="loading"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/os/os/form.vue